import React, { useEffect, useMemo, useState } from 'react';
import { ArrowRightIcon } from 'lucide-react';
const categories = [{
  name: 'Accounting',
  slug: 'accounting',
  count: '12,400+'
}, {
  name: 'Auto Repair',
  slug: 'auto-repair',
  count: '85,000+'
}, {
  name: 'Architecture',
  slug: 'architecture',
  count: '14,200+'
}, {
  name: 'Assisted Living',
  slug: 'assisted-living',
  count: '9,800+'
}, {
  name: 'Appliance Repair',
  slug: 'appliance-repair',
  count: '11,500+'
}, {
  name: 'Bakeries',
  slug: 'bakeries',
  count: '22,100+'
}, {
  name: 'Barber Shops',
  slug: 'barber-shops',
  count: '45,300+'
}, {
  name: 'Beauty Salons',
  slug: 'beauty-salons',
  count: '112,000+'
}, {
  name: 'Bookkeeping',
  slug: 'bookkeeping',
  count: '18,400+'
}, {
  name: 'Building Contractors',
  slug: 'building-contractors',
  count: '67,800+'
}, {
  name: 'Car Dealers',
  slug: 'car-dealer',
  count: '34,500+'
}, {
  name: 'Catering',
  slug: 'catering',
  count: '19,200+'
}, {
  name: 'Chiropractic',
  slug: 'chiropractic',
  count: '28,900+'
}, {
  name: 'Cleaning Services',
  slug: 'cleaning-services',
  count: '56,700+'
}, {
  name: 'Construction',
  slug: 'construction',
  count: '145,000+'
}, {
  name: 'CPA Firms',
  slug: 'cpa-firms',
  count: '21,300+'
}, {
  name: 'Dental Clinics',
  slug: 'dental-clinics',
  count: '42,100+'
}, {
  name: 'Dermatology',
  slug: 'dermatology',
  count: '8,400+'
}, {
  name: 'Dog Grooming',
  slug: 'dog-grooming',
  count: '15,600+'
}, {
  name: 'Dry Cleaning',
  slug: 'dry-cleaning',
  count: '12,800+'
}, {
  name: 'Electricians',
  slug: 'electricians',
  count: '48,900+'
}, {
  name: 'Event Planning',
  slug: 'event-planning',
  count: '11,200+'
}, {
  name: 'Eye Care',
  slug: 'eye-care',
  count: '14,500+'
}, {
  name: 'Financial Advisors',
  slug: 'financial-advisors',
  count: '32,400+'
}, {
  name: 'Fitness Centers',
  slug: 'fitness-centers',
  count: '26,700+'
}, {
  name: 'Flooring',
  slug: 'flooring',
  count: '18,900+'
}, {
  name: 'Florists',
  slug: 'florists',
  count: '13,400+'
}, {
  name: 'Funeral Homes',
  slug: 'funeral-homes',
  count: '9,200+'
}, {
  name: 'General Contractors',
  slug: 'general-contractors',
  count: '89,000+'
}, {
  name: 'Graphic Design',
  slug: 'graphic-design',
  count: '24,500+'
}, {
  name: 'Gyms',
  slug: 'gyms',
  count: '21,800+'
}, {
  name: 'Hair Salons',
  slug: 'hair-salons',
  count: '98,000+'
}, {
  name: 'Handyman Services',
  slug: 'handyman-services',
  count: '34,200+'
}, {
  name: 'HVAC',
  slug: 'hvac',
  count: '41,500+'
}, {
  name: 'Home Inspection',
  slug: 'home-inspection',
  count: '12,300+'
}, {
  name: 'Hotels',
  slug: 'hotels',
  count: '38,900+'
}, {
  name: 'Insurance Agencies',
  slug: 'insurance-agencies',
  count: '65,400+'
}, {
  name: 'Interior Design',
  slug: 'interior-design',
  count: '16,700+'
}, {
  name: 'IT Services',
  slug: 'it-services',
  count: '29,800+'
}, {
  name: 'Janitorial Services',
  slug: 'janitorial-services',
  count: '31,200+'
}, {
  name: 'Jewelry Stores',
  slug: 'jewelry-stores',
  count: '14,500+'
}, {
  name: 'Kennels',
  slug: 'kennels',
  count: '8,900+'
}, {
  name: 'Kitchen Remodeling',
  slug: 'kitchen-remodeling',
  count: '22,400+'
}, {
  name: 'Landscaping',
  slug: 'landscaping',
  count: '76,500+'
}, {
  name: 'Laundromats',
  slug: 'laundromats',
  count: '11,200+'
}, {
  name: 'Law Firms',
  slug: 'law-firms',
  count: '82,300+'
}, {
  name: 'Locksmiths',
  slug: 'locksmiths',
  count: '9,800+'
}, {
  name: 'Marketing Agencies',
  slug: 'marketing-agencies',
  count: '35,600+'
}, {
  name: 'Massage Therapy',
  slug: 'massage-therapy',
  count: '28,400+'
}, {
  name: 'Medical Clinics',
  slug: 'medical-clinics',
  count: '54,200+'
}, {
  name: 'Moving Companies',
  slug: 'moving-companies',
  count: '19,500+'
}, {
  name: 'Nail Salons',
  slug: 'nail-salons',
  count: '42,800+'
}, {
  name: 'Notary Services',
  slug: 'notary-services',
  count: '15,400+'
}, {
  name: 'Nursing Homes',
  slug: 'nursing-homes',
  count: '12,100+'
}, {
  name: 'Optometry',
  slug: 'optometry',
  count: '16,800+'
}, {
  name: 'Orthodontics',
  slug: 'orthodontics',
  count: '9,500+'
}, {
  name: 'Organic Stores',
  slug: 'organic-stores',
  count: '6,400+'
}, {
  name: 'Painting',
  slug: 'painting',
  count: '38,200+'
}, {
  name: 'Pest Control',
  slug: 'pest-control',
  count: '18,700+'
}, {
  name: 'Pet Stores',
  slug: 'pet-stores',
  count: '11,900+'
}, {
  name: 'Photography',
  slug: 'photography',
  count: '26,300+'
}, {
  name: 'Plumbing',
  slug: 'plumbing',
  count: '52,100+'
}, {
  name: 'Printing',
  slug: 'printing',
  count: '14,200+'
}, {
  name: 'Property Management',
  slug: 'property-management',
  count: '31,500+'
}, {
  name: 'Real Estate',
  slug: 'real-estate',
  count: '115,000+'
}, {
  name: 'Restaurants',
  slug: 'restaurants',
  count: '345,000+'
}, {
  name: 'Roofing',
  slug: 'roofing',
  count: '44,800+'
}, {
  name: 'Security Services',
  slug: 'security-services',
  count: '13,600+'
}, {
  name: 'Spas',
  slug: 'spas',
  count: '21,400+'
}, {
  name: 'Staffing Agencies',
  slug: 'staffing-agencies',
  count: '25,900+'
}, {
  name: 'Storage Facilities',
  slug: 'storage-facilities',
  count: '17,200+'
}, {
  name: 'Tax Preparation',
  slug: 'tax-preparation',
  count: '36,500+'
}, {
  name: 'Towing',
  slug: 'towing',
  count: '14,800+'
}, {
  name: 'Travel Agencies',
  slug: 'travel-agencies',
  count: '9,400+'
}, {
  name: 'Tree Services',
  slug: 'tree-services',
  count: '18,300+'
}, {
  name: 'Tutoring',
  slug: 'tutoring',
  count: '15,700+'
}, {
  name: 'Veterinary Clinics',
  slug: 'veterinary-clinics',
  count: '24,100+'
}, {
  name: 'Video Production',
  slug: 'video-production',
  count: '8,600+'
}, {
  name: 'Web Design',
  slug: 'web-design',
  count: '22,500+'
}, {
  name: 'Wedding Planning',
  slug: 'wedding-planning',
  count: '7,200+'
}, {
  name: 'Window Cleaning',
  slug: 'window-cleaning',
  count: '11,400+'
}, {
  name: 'Yoga Studios',
  slug: 'yoga-studios',
  count: '13,800+'
}];
interface DataDirectoryCategoryBrowserProps {
  searchQuery: string;
}
export function DataDirectoryCategoryBrowser({
  searchQuery
}: DataDirectoryCategoryBrowserProps) {
  const [activeLetter, setActiveLetter] = useState<string>('A');
  const filteredCategories = useMemo(() => {
    if (!searchQuery) return categories;
    return categories.filter(c => c.name.toLowerCase().includes(searchQuery.toLowerCase()));
  }, [searchQuery]);
  const groupedCategories = useMemo(() => {
    const groups: Record<string, typeof categories> = {};
    filteredCategories.forEach(c => {
      const letter = c.name.charAt(0).toUpperCase();
      if (!groups[letter]) groups[letter] = [];
      groups[letter].push(c);
    });
    return groups;
  }, [filteredCategories]);
  const availableLetters = Object.keys(groupedCategories).sort();
  const allLetters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
  const scrollToLetter = (letter: string) => {
    setActiveLetter(letter);
    const element = document.getElementById(`letter-${letter}`);
    if (element) {
      const yOffset = -100;
      const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({
        top: y,
        behavior: 'smooth'
      });
    }
  };
  useEffect(() => {
    const handleScroll = () => {
      const letterElements = availableLetters.map(letter => ({
        letter,
        element: document.getElementById(`letter-${letter}`)
      }));
      for (let i = letterElements.length - 1; i >= 0; i--) {
        const {
          letter,
          element
        } = letterElements[i];
        if (element) {
          const rect = element.getBoundingClientRect();
          if (rect.top <= 150) {
            setActiveLetter(letter);
            break;
          }
        }
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [availableLetters]);
  return <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-677">
      <div className="bg-white rounded-[2.5rem] shadow-sm border border-slate-100 p-8 md:p-12 lg:p-16" data-id="element-678">
        {/* A-Z Navigation */}
        <div className="sticky top-0 z-20 bg-white/90 backdrop-blur-md py-4 border-b border-slate-100 mb-12 -mx-4 px-4 sm:mx-0 sm:px-0" data-id="element-679">
          <div className="flex flex-wrap justify-center gap-2" data-id="element-680">
            {allLetters.map(letter => {
            const isAvailable = availableLetters.includes(letter);
            const isActive = activeLetter === letter && isAvailable;
            return <button key={letter} onClick={() => isAvailable && scrollToLetter(letter)} disabled={!isAvailable} className={`w-8 h-8 sm:w-10 sm:h-10 rounded-xl flex items-center justify-center text-sm font-bold transition-all
                    ${isActive ? 'bg-blue-600 text-white shadow-sm' : isAvailable ? 'bg-slate-50 text-slate-600 hover:bg-blue-50 hover:text-blue-600 cursor-pointer border border-slate-100' : 'bg-transparent text-slate-300 cursor-not-allowed'}`} data-id="element-681">
                  {letter}
                </button>;
          })}
          </div>
        </div>

        {/* Categories Grid */}
        {availableLetters.length > 0 ? <div className="space-y-16" data-id="element-682">
            {availableLetters.map(letter => <div key={letter} id={`letter-${letter}`} className="scroll-mt-32" data-id="element-683">
                <div className="flex items-baseline gap-4 mb-8 border-b border-slate-100 pb-4" data-id="element-684">
                  <h2 className="text-4xl font-bold text-slate-900 tracking-tight" data-id="element-685">
                    {letter}
                  </h2>
                  <span className="text-sm font-bold text-slate-400 uppercase tracking-wider" data-id="element-686">
                    {groupedCategories[letter].length} categories
                  </span>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4" data-id="element-687">
                  {groupedCategories[letter].map(category => {
              const href = category.slug === 'accounting' ? '#/data/accounting' : `https://www.openmart.com/data/${category.slug}`;
              return <a key={category.name} href={href} className="group bg-slate-50 border border-slate-100 rounded-2xl p-6 hover:border-blue-200 hover:shadow-md hover:bg-white transition-all flex flex-col" data-id="element-688">
                        <h3 className="text-lg font-bold text-slate-900 mb-2 group-hover:text-blue-600 transition-colors tracking-tight" data-id="element-689">
                          {category.name}
                        </h3>
                        <div className="flex items-center justify-between mt-auto pt-4" data-id="element-690">
                          <span className="text-sm font-semibold text-slate-500" data-id="element-691">
                            {category.count} listings
                          </span>
                          <div className="w-8 h-8 rounded-full bg-white border border-slate-200 flex items-center justify-center group-hover:bg-blue-600 group-hover:border-blue-600 transition-colors" data-id="element-692">
                            <ArrowRightIcon className="w-4 h-4 text-slate-400 group-hover:text-white transition-colors" data-id="element-693" />
                          </div>
                        </div>
                      </a>;
            })}
                </div>
              </div>)}
          </div> : <div className="text-center py-24 bg-slate-50 rounded-3xl border border-slate-100" data-id="element-694">
            <h3 className="text-2xl font-bold text-slate-900 mb-2 tracking-tight" data-id="element-695">
              No categories found
            </h3>
            <p className="text-slate-500 text-lg" data-id="element-696">
              Try adjusting your search query.
            </p>
          </div>}
      </div>
    </section>;
}